import { NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

@NeoModel
export default class SARSNatureOfPerson extends TemporalEntity {
    static typeName = "SARSNatureOfPerson";

    public sarsNatureOfPersonId: number = 0;

    @Rules.StringLength(255)
    @Rules.Required()
    public code: string = "";

    @Rules.StringLength(255)
    @Rules.Required()
    public description: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.code) {
            return "New sars nature of person";
        } else {
            return this.code;
        }
    }
}